import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reorder',
  pure: false, // Ensure the pipe updates when data changes
})
export class ReorderPipe implements PipeTransform {
  transform(items: any[], item: any[], key: string, label: string): any[] {
    if (!items || !item || !key || !label) return items;

    const checkedValues = items.filter(f => item.includes(f[key]));
    const uncheckedValues = items.filter(f => !item.includes(f[key]));

    // "Selected Item" Label
    const selectedItemLabel = { [label]: `${item.length} Selected Item`, disabled: true };

    if (!items.find(f => f[label]?.includes('Selected Item'))) {
      return [selectedItemLabel, ...checkedValues, ...uncheckedValues];
    } else {
      // Update the count in the "Selected Item" label
      const updatedList = [...checkedValues, ...uncheckedValues];
      let index = updatedList.findIndex(f => f[label]?.includes('Selected Item'));
      if (index !== -1) {
        updatedList.splice(index, 1); // Remove old label
      }
      return [selectedItemLabel, ...updatedList];
    }
  }
}
